export var oteljsVersion = '4.20.18';
//# sourceMappingURL=Version.js.map